import type { IProjectLaborDistributionEntry } from '@/interfaces'

import { addToJSON } from './helper'

export class ProjectLaborDistributionEntry implements IProjectLaborDistributionEntry {
	date: Date
	hours: number
	constructor({ date, hours }: Partial<IProjectLaborDistributionEntry> = {}) {
		this.date = date || new Date()
		this.hours = hours || 0
		addToJSON(ProjectLaborDistributionEntry)
	}
	get dateString(): string {
		return this.date.toLocaleDateString('en-US')
	}
}
